import { render, staticRenderFns } from "./actDistributionByStaff.vue?vue&type=template&id=0d958a03&scoped=true&"
import script from "./actDistributionByStaff.vue?vue&type=script&lang=js&"
export * from "./actDistributionByStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d958a03",
  null
  
)

export default component.exports